{
  "changeChain": {
    "title": "Выберите сеть"
  },
  "checkoutBlocked": {
    "notAvailable": "Недоступно",
    "regionMessage": "Этот сервис недоступен в вашем регионе.",
    "viewRegions": "Посмотреть доступные регионы."
  },
  "common": {
    "addressCopied": "Адрес скопирован",
    "back": "Назад",
    "cancel": "Отмена",
    "close": "Закрыть",
    "confirm": "Подтвердить",
    "continue": "Продолжить",
    "copied": "Скопировано!",
    "copy": "Копировать",
    "copyAddress": "Скопировать адрес",
    "done": "Готово",
    "go": "Перейти",
    "loading": "Загрузка…",
    "ok": "ОК",
    "poweredBy": "работает на",
    "tryAgain": "Попробовать снова",
    "startOver": "Начать заново"
  },
  "depositAmount": {
    "amountLabel": "Сумма",
    "changeToMaximum": "Изменить на максимум",
    "changeToMinimum": "Изменить на минимум",
    "delete": "Удалить",
    "enterAmount": "Введите сумму",
    "fee": "Комиссия {{amount}}",
    "maximumAmount": "Максимальный депозит {{amount}}",
    "minimumAmount": "Минимальный депозит {{amount}}",
    "title": "Пополнение",
    "submit": "Пополнить",
    "submitWithMethod": "Пополнить через {{method}}"
  },
  "feeDetails": {
    "amount": "Сумма",
    "fee": "Комиссия {{rate}}",
    "summaryAddedToCharge": "Пополнение через {{method}} облагается комиссией {{rate}}, которая будет добавлена к общей сумме списания.",
    "summaryDeductedFromDeposit": "Пополнение через {{method}} облагается комиссией {{rate}}, которая будет вычтена из получаемой суммы.",
    "title": "Детали комиссии",
    "totalCost": "Итого к оплате",
    "youllGet": "Вы получите"
  },
  "fiat": {
    "agreeAndContinue": "Принять условия и продолжить",
    "amountLabel": "Сумма депозита",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Добавьте карту в Apple Wallet и повторите попытку.",
    "applePayUnsupported": "Это устройство не может платить через Apple Pay.",
    "blocked": "Депозиты недоступны в вашем регионе",
    "card": "Карта",
    "contactVerifyBoth": "Подтвердите номер телефона и адрес электронной почты",
    "contactVerifyEmail": "Подтвердите адрес электронной почты",
    "contactVerifyPhone": "Подтвердите номер телефона",
    "countryHeading": "Ваша страна",
    "countrySearchPlaceholder": "Поиск",
    "delete": "Удалить",
    "deposit": "Внести",
    "depositReceived": "Депозит {{amount}} получен",
    "depositReceivedFrom": "через {{method}}",
    "emailPlaceholder": "Ваша почта",
    "failure": "Не удалось выполнить депозит",
    "fee": "Комиссия {{amount}}",
    "getNewPrice": "Получить новую цену",
    "kycConsentCheck": "Я разрешаю Fun проверить мою личность и передать результат платёжному провайдеру, который обрабатывает мой заказ. Подробнее — в нашей",
    "kycConsentPrompt": "Продолжая, вы разрешаете Fun проверить вашу личность и передать результат платёжному провайдеру, который обрабатывает ваш заказ. Подробнее — в нашей",
    "kycConsentStop": ".",
    "kycDetailAddress": "Укажите ваш адрес",
    "kycDetailDob": "Укажите дату рождения",
    "kycDetailName": "Нам нужно больше сведений о вашей личности, чтобы защитить ваш депозит.",
    "kycDetailNationality": "Ваше гражданство",
    "kycDetailOther": "Укажите оставшиеся данные",
    "kycDetailSsn": "Укажите ваш 9-значный SSN",
    "kycFileUnsupported": "Загрузка документов здесь еще не доступна — вы сможете завершить этот шаг позже.",
    "kycFormDetail": "Перед первым депозитом нужно указать несколько данных.",
    "kycFormInvalid": "Некоторые данные нужно проверить ещё раз.",
    "kycPhoneInUse": "Этот номер телефона уже используется в другом аккаунте {{provider}}. Укажите другой номер.",
    "kycTaxIdInUse": "Этот налоговый номер уже используется в другом аккаунте {{provider}}.",
    "kycFormMissing": "Не хватает обязательных данных.",
    "kycFormStale": "Этот шаг изменился. Проверьте данные ниже.",
    "kycFormTitle": "Подтвердите личность",
    "kycIntroDetail": "Это позволяет нам обрабатывать ваши депозиты и защищать вашу учётную запись. Займёт всего минуту, документы не нужны.",
    "kycNoticeCountryCode": "Укажите двухбуквенный код страны, например AU",
    "kycNoticeDateFormat": "Используйте формат ГГГГ-ММ-ДД",
    "kycNoticeDatePast": "Укажите дату в прошлом",
    "kycNoticeInvalid": "Проверьте выделенные поля",
    "kycNoticeRequired": "Заполните выделенные поля",
    "kycNoticeUnderage": "Для продолжения вам должно быть не менее 18 лет",
    "kycOnHold": "Проверка приостановлена",
    "kycOnHoldDetail": "Вы можете вернуться и попробовать снова позже.",
    "kycOnHoldUntil": "Повторить попытку можно {{date}}.",
    "kycOpenLink": "Продолжить проверку",
    "kycOptional": "необязательно",
    "kycPrivacyPolicy": "Политике конфиденциальности",
    "kycProviderGeneric": "платёжного провайдера",
    "kycProviderGenericId": "нашего партнёра по проверке",
    "kycProviderTerms": "условиями {{provider}}",
    "kycProviderTermsPrompt": "Продолжая, вы соглашаетесь с",
    "kycRejected": "Проверка не пройдена",
    "kycRejectedSupport": "Свяжитесь с поддержкой — мы разберёмся.",
    "kycRequired": "Проверить и внести",
    "kycRequiredCta": "Требуется проверка →",
    "kycRequiredDetail": "Завершите проверку, чтобы продолжить пополнение.",
    "kycRequiredTitle": "Требуется подтверждение личности",
    "kycCompleteDetail": "Ваш лимит на пополнение увеличен.",
    "kycCompleteTitle": "Проверка личности завершена",
    "kycHardCta": "Посмотреть варианты →",
    "kycHardDetail": "Мы не можем увеличить ваш лимит на пополнение с помощью проверки личности.",
    "kycHardTitle": "Не удалось подтвердить личность",
    "kycPendingCta": "Ожидание проверки →",
    "kycPendingDetail": "Мы работаем над тем, чтобы завершить проверку как можно быстрее.",
    "kycPendingTitle": "Проверка личности выполняется",
    "kycSoftCta": "Требуется проверка →",
    "kycSoftDetail": "Вы можете повторить попытку и исправить ошибки проверки.",
    "kycSoftTitle": "Проверка личности не удалась",
    "kycOptionCloseDetail": "Выйдите и вернитесь к этому депозиту позже.",
    "kycOptionCloseTitle": "Закрыть депозит",
    "kycOptionMaxDetail": "До проверки — не более {{max}}.",
    "kycOptionMaxDetailUnknown": "До проверки — в пределах текущего лимита.",
    "kycOptionMaxTitle": "Пополнить на максимум",
    "kycOptionRedoDetail": "Проверьте свои данные и документы и попробуйте ещё раз.",
    "kycOptionRedoTitle": "Пройти проверку личности заново",
    "kycOptionSupportDetail": "Свяжитесь с нами, чтобы решить вопросы с требованиями проверки личности.",
    "kycOptionSupportTitle": "Помощь и поддержка",
    "kycOptionsHardTitle": "Мы не можем увеличить ваш лимит на пополнение после проверки личности.",
    "kycOptionsLabel": "Сейчас вы можете:",
    "kycOptionsPendingTitle": "Проверка личности ещё выполняется. Ваши лимиты на пополнение пока не изменились.",
    "kycOptionsSoftTitle": "Проверка личности не удалась. Повторите попытку и исправьте ошибки прошлой попытки.",
    "kycTitle": "Подтверждение личности",
    "otpDetailAnyEmail": "Код отправлен на вашу почту",
    "otpDetailAnyPhone": "Код отправлен на ваш телефон",
    "otpDetailEmail": "Код отправлен на {{email}}",
    "otpDetailPhone": "Код отправлен на {{phone}}",
    "otpError": "Этот код не сработал. Проверьте его и попробуйте снова.",
    "otpExpired": "Срок действия кода истёк. Запросите новый.",
    "otpRateLimited": "Запрошено слишком много кодов. Подождите, прежде чем повторить попытку.",
    "otpRateLimitedTitle": "Подождите, прежде чем запросить другой код",
    "otpPlaceholder": "6-значный код",
    "otpResend": "Отправить снова",
    "otpResendPrompt": "Не получили код?",
    "otpTitle": "Введите код",
    "payButton": "Внести через Apple Pay",
    "paySheetPay": "Оплатить",
    "paySheetTitle": "Подтвердить через Apple Pay",
    "paySheetTotal": "Итого {{amount}}",
    "phoneCountryLabel": "Код страны",
    "phoneCountrySearch": "Поиск страны",
    "phonePlaceholder": "Ваш номер телефона",
    "processing": "Обработка депозита…",
    "pendingOrderTitle": "У вас есть незавершённое пополнение",
    "pendingOrderDetail": "Продолжите пополнение на {{amount}} или отмените его, чтобы указать новую сумму.",
    "resumeDeposit": "Продолжить пополнение",
    "cancelDeposit": "Отменить пополнение",
    "quoteExpired": "Эта цена истекла",
    "quoteFailed": "Не удалось получить цену",
    "redirectDetail": "Мы обновим этот экран, как только вы вернётесь.",
    "redirectReopen": "Снова открыть браузер",
    "redirectTitle": "Завершите оплату в браузере",
    "refunded": "Депозит возвращён",
    "refusalDetails": "Проверьте введённые данные и попробуйте ещё раз.",
    "refusalDetailsTitle": "Некоторые данные нужно перепроверить",
    "refusalLimits": "Попробуйте меньшую сумму или другой способ оплаты.",
    "refusalLimitsTitle": "Этот способ оплаты не принимает такую сумму",
    "refusalUnavailable": "Проблема на нашей стороне: попробуйте ещё раз через минуту или укажите меньшую сумму.",
    "refusalUnavailableTitle": "Сейчас нет доступных способов оплаты",
    "requote": "Получить новую котировку",
    "reviewTitle": "Подтвердите депозит",
    "orderConfirmingTitle": "Подтверждаем ваш платёж",
    "orderConfirmingDetail": "Платёж прошёл. Мы записываем ваш депозит, это может занять некоторое время.",
    "submitFailed": "Не удалось отправить",
    "paymentFailed": "Попробуйте ещё раз",
    "submitting": "Отправка",
    "stripeAuthDetail": "Мы используем {{email}}, чтобы безопасно продолжить работу с Link.",
    "stripeAuthorizing": "Продолжить в Stripe",
    "stripeAuthorizingDetail": "Завершите проверку и предоставьте согласие Link в окне Stripe.",
    "stripeAuthTitle": "Продолжить со Stripe",
    "stripeAuthFailed": "Не удалось начать сессию Stripe. Повторите попытку.",
    "stripeKycInfoFailed": "Не удалось сохранить ваши данные в Stripe. Проверьте их и повторите попытку.",
    "stripeRegistrationFailed": "Не удалось создать аккаунт Link. Проверьте данные и повторите попытку.",
    "success": "Депозит выполнен",
    "successDetail": "Ваш баланс обновится через мгновение.",
    "termsNotice": "Продолжая, вы принимаете\n<terms>Условия</terms> провайдера.",
    "unsupported": "Этот шаг пока недоступен",
    "verifying": "Проверка личности…",
    "verifyingDetail": "Обычно это занимает меньше минуты.",
    "verifyingSlow": "Проверка продолжается",
    "verifyingSlowDetail": "Можно закрыть и вернуться чуть позже.",
    "coinbaseTermsNotice": "Продолжая, вы принимаете\n<terms>Условия</terms>, <agreement>Пользовательское соглашение</agreement> и <privacy>Политику конфиденциальности</privacy> Coinbase.",
    "contactInvalidEmail": "Введите действительный адрес электронной почты",
    "kycIntroTitle": "Подтвердим вашу личность",
    "kycAdditionalTitle": "Нужно немного больше информации",
    "kycAdditionalDetail": "Для увеличения лимитов пополнения нужна дополнительная проверка. Повышенные лимиты будут доступны сразу после её завершения.",
    "kycFindOutMore": "Подробнее",
    "kycR2Consent": "Продолжая, вы соглашаетесь на проверку вашей личности компанией Fun и передачу результатов выбранным платёжным провайдерам.",
    "kycAgreeContinue": "Согласиться и продолжить",
    "kycSsnLastFour": "Введите последние\n4 цифры вашего SSN",
    "kycSsnProtection": "По законодательству США мы обязаны собирать SSN для проверки личности. Ваши данные защищены шифрованием банковского уровня.",
    "kycDetailCountry": "Ваша страна",
    "kycCountry": "Страна",
    "kycDetailOccupation": "Ваш род занятий",
    "kycDetailPurpose": "Укажите цель транзакции",
    "kycOccupation": "Род занятий",
    "kycPurpose": "Цель транзакции",
    "kycDetailPhone": "Ваш номер мобильного телефона",
    "kycDetailEmployment": "Ваш статус занятости",
    "kycDetailSourceOfWealth": "Источник вашего благосостояния",
    "kycDetailIncome": "Ваш валовой годовой доход",
    "kycDetailActivity": "Ваша ежемесячная активность",
    "kycIncomeCaption": "До вычета налогов, в местной валюте",
    "kycReviewTitle": "Спасибо! Ваши данные получены и проверяются.",
    "kycHoldTitle": "Спасибо! Ваши данные получены. Нам нужно немного больше времени для завершения проверки.",
    "kycRestrictedTitle": "Ваш аккаунт ограничен.",
    "regionUnsupportedTitle": "Ваш регион не поддерживается.",
    "kycAnyQuestions": "Есть вопросы?",
    "kycGetHelpSupport": "Получить помощь и поддержку",
    "otpVerified": "Код подтверждён",
    "authConnectFailedTitle": "Не удалось подключить ваш аккаунт {{provider}}",
    "authConnectFailedDetail": "Начните заново, чтобы войти с самого начала.",
    "kycUnavailableTitle": "Проверка временно недоступна.",
    "kycUnavailableNetwork": "Повторите попытку через минуту или вернитесь позже.",
    "kycUnavailableProviderTitle": "Не удалось пройти проверку.",
    "kycUnavailableProvider": "На нашей стороне произошла ошибка. Свяжитесь с поддержкой, и мы разберёмся.",
    "contactSupport": "Связаться с поддержкой",
    "kycDocumentTitle": "Проверка документов",
    "kycDocumentDetail": "Нам нужно проверить ваш документ, чтобы завершить проверку. Проверку личности обеспечивает {{provider}}.",
    "kycDocumentContinue": "Проверить документ через {{provider}}",
    "applePayUnavailableTitle": "Apple Pay временно недоступен.",
    "kycLimitNotice": "Дневной лимит достигнут: пройдите проверку, чтобы сразу повысить лимиты.",
    "contactEmailRejected": "Не удаётся подтвердить этот адрес электронной почты. Выберите другой адрес.",
    "contactReverifyPhone": "Пожалуйста, подтвердите свой номер телефона ещё раз.",
    "coinbaseCardSoftDeclined": "Банк отклонил платёж. Попробуйте другую карту в Apple Pay или обратитесь в банк.",
    "coinbaseCardHardDeclined": "Банк отклонил эту карту. Используйте другую карту в Apple Pay.",
    "coinbaseCardRiskDeclined": "Платёж не удалось одобрить. Попробуйте другую карту в Apple Pay.",
    "coinbaseInvalidCard": "Проверьте карту и платёжный адрес в Apple Pay и повторите попытку.",
    "coinbaseInsufficientBalance": "На этой карте недостаточно средств для пополнения.",
    "coinbasePrepaidCard": "Предоплаченные карты не принимаются. Используйте дебетовую карту в Apple Pay.",
    "coinbaseRegionUnsupported": "Пополнение картой недоступно в вашем регионе.",
    "coinbasePermissionDenied": "Этот способ оплаты недоступен для вашего аккаунта.",
    "coinbaseWeeklyLimit": "Это превысит недельный лимит пополнения картой. Попробуйте меньшую сумму.",
    "coinbaseLifetimeCount": "Вы исчерпали все пополнения картой, доступные без аккаунта Coinbase.",
    "coinbaseDailyCount": "Вы достигли дневного лимита пополнений картой. Попробуйте завтра.",
    "coinbaseBillingZip": "Почтовый индекс не совпадает с данными карты. Проверьте его и повторите попытку.",
    "coinbaseBillingAddress": "Платёжный адрес указан не полностью. Проверьте его и повторите попытку.",
    "coinbaseBillingName": "Имя держателя карты не принято. Проверьте его и повторите попытку.",
    "coinbaseSessionExpired": "Платёжная сессия истекла. Начните пополнение заново.",
    "coinbaseNetworkUnsupported": "Эта сеть недоступна в вашем регионе.",
    "coinbaseAssetUnsupported": "Этот токен недоступен в вашем регионе.",
    "coinbaseProviderError": "Coinbase не смог завершить операцию. Повторите попытку через минуту.",
    "coinbaseBuyFailed": "Покупку не удалось завершить. Списание с карты не производилось.",
    "coinbaseSendFailed": "Пополнение не доставлено. Средства вернутся на карту.",
    "coinbaseAvsFailed": "Не удалось проверить платёжный адрес. Уточните его в банке и повторите попытку.",
    "cancelled": "Пополнение отменено",
    "sessionExpired": "Сессия истекла. Войдите снова, чтобы продолжить пополнение.",
    "accountIneligibleTitle": "Пополнение недоступно для этого аккаунта",
    "accountIneligibleDetail": "Свяжитесь с поддержкой, если считаете, что это ошибка."
  },
  "fops": {
    "bankTransferSubtitle": "Лимит {{limit}} · 1–2 дня",
    "bankTransferTime": "1–2 дня",
    "instant": "Мгновенно",
    "limit": "Лимит {{limit}}"
  },
  "networks": {
    "chainFallback": "Сеть {{chainId}}",
    "minimum": "Минимум ${{min}}"
  },
  "qrCode": {
    "title": "QR-код"
  },
  "selectChain": {
    "subtitle": "Выберите сеть для внесения средств",
    "title": "Внести криптовалюту"
  },
  "selectMethod": {
    "crypto": "Криптовалюта",
    "depositTo": "Зачислить на",
    "errorMessage": "Не удалось загрузить данные.\nПроверьте подключение к интернету и попробуйте снова.",
    "errorTitle": "Что-то пошло не так",
    "loadingMethods": "Загрузка способов оплаты",
    "noLimit": "Без лимита",
    "payWith": "Оплатить с помощью",
    "title": "Пополнить"
  },
  "selectReceiveToken": {
    "availableTokens": "Доступные токены",
    "moreTokens_few": "+{{count}} токена",
    "moreTokens_many": "+{{count}} токенов",
    "moreTokens_one": "+{{count}} токен",
    "moreTokens_other": "+{{count}} токена",
    "searchTokens": "Поиск токена",
    "selectChain": "Выберите сеть",
    "selectToken": "Выберите токен",
    "title": "Токен и сеть получения"
  },
  "transferCrypto": {
    "changeChain": "Изменить сеть",
    "depositAddressLabel": "Ваш адрес для депозита",
    "generating": "Генерация…",
    "selectedChain": "Выбранная сеть",
    "share": "Поделиться",
    "shareAddress": "Поделиться адресом",
    "showQrCode": "Показать QR-код",
    "title": "Перевод криптовалюты"
  },
  "withdraw": {
    "belowMinimumMessage": "Ваш баланс ниже минимума для вывода наличных.",
    "belowMinimumTitle": "Недостаточный баланс",
    "cashMethodsError": "Не удалось загрузить способы вывода наличных. Вывод в криптовалюте по-прежнему доступен.",
    "noCashMethods": "Вывод на банк или карту недоступен в вашем регионе. Вывод в криптовалюте по-прежнему доступен.",
    "title": "Вывести",
    "unavailableMessage": "Вывод наличных сейчас недоступен в вашем регионе.",
    "unavailableTitle": "Вывод недоступен"
  },
  "withdrawAddress": {
    "breakdown": "Вы получите примерно {{amount}}. Сумма может немного измениться из-за состояния сети. Сделка не будет исполнена по цене ниже {{minimum}}. Транзакция должна завершиться за несколько секунд.",
    "breakdownTitle": "Детали транзакции",
    "clear": "Очистить",
    "detected": "Кошелёк распознан",
    "notFound": "Кошелёк не найден",
    "paste": "Вставить",
    "requested": "Вывод запрошен",
    "title": "Вывести {{amount}}",
    "useConnected": "Использовать подключённый",
    "withdrawNow": "Вывести сейчас",
    "withdrawing": "Выводим",
    "withdrew": "Выведено",
    "youllReceive": "Вы получите"
  },
  "withdrawAmount": {
    "amountLabel": "Сумма",
    "delete": "Удалить",
    "swapDenomination": "Переключить доллары и токены",
    "useMax": "Использовать максимум"
  },
  "withdrawCrypto": {
    "aboveBalance": "Недостаточно средств",
    "addressPlaceholder": "Адрес кошелька",
    "available": "Доступно: {{amount}} {{symbol}}",
    "belowFee": "Сумма должна превышать комиссию {{amount}}",
    "belowMinimum": "Минимальная сумма составляет {{amount}}",
    "ctaInvalidForChain": "Адрес недействителен для этой сети",
    "ctaMaxExceeded": "Превышена максимальная сумма",
    "ctaRecipientSameAsSource": "Выберите другой адрес",
    "ctaSelectDestination": "Выберите получателя",
    "errorGeneric": "Не удалось выполнить вывод. Попробуйте снова.",
    "errorInsufficientGas": "Недостаточно газа для этой транзакции",
    "errorSwitchChain": "Не удаётся переключить сети. Пожалуйста, убедитесь, что ваш кошелёк поддерживает эту сеть.",
    "failedMessage": "{{amount}} не дошли до получателя. Свяжитесь с поддержкой, если средства не вернутся.",
    "failedTitle": "Вывод не завершён",
    "max": "Макс.",
    "methodSubtitle": "Без лимита",
    "methodTitle": "Крипто-адрес",
    "quoteFailed": "Не удалось получить котировку обмена. Пожалуйста, попробуйте снова.",
    "receiveAs": "Получить в",
    "refundedMessage": "{{amount}} возвращены в ваш кошелёк.",
    "riskyAddress": "Этот адрес кошелька не может быть использован из-за ограничений.",
    "selectSource": "Выберите источник",
    "sendFrom": "Вывести из",
    "successPendingMessage": "{{amount}} обрабатывается в сети. Можно закрыть это окно.",
    "successPendingTitle": "Вывод отправлен",
    "title": "Вывод криптовалюты",
    "unsupportedRecipient": "Неподдерживаемый адрес получателя"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}} ч",
    "delayHoursMinutes": "{{hours}} ч {{minutes}} мин",
    "delayMinutes": "{{minutes}} мин",
    "delaySecond": "1 секунда",
    "delaySeconds": "{{seconds}} секунд",
    "fastDisclaimer": "Только USDC бессрочные · Несколько сетей · Мгновенно",
    "fastDisclaimerUnified": "Только USDC · Несколько сетей · Мгновенно",
    "methodFast": "Быстрый",
    "methodSecure": "Нативный мост",
    "secureDisclaimer": "Все токены · Только сеть Ethereum · {{delay}}",
    "secureFallbackDelay": "60+ минут"
  },
  "withdrawNado": {
    "errorAmountTooLow": "Сумма слишком мала, чтобы покрыть комиссию за вывод Nado.",
    "errorBalanceChanged": "Доступная для вывода сумма изменилась. Нажмите «Макс» и попробуйте снова.",
    "errorInvalidNonce": "Срок этого запроса на вывод истёк. Попробуйте снова.",
    "errorNetwork": "Сейчас нет связи с Nado. Попробуйте снова.",
    "errorNoPriorDeposit": "Внесите средства в Nado перед выводом.",
    "errorRateLimited": "Слишком много запросов. Подождите немного и попробуйте снова.",
    "errorSignerMismatch": "Чтобы вывести средства, вернитесь к кошельку, которому принадлежит этот аккаунт Nado.",
    "errorUnconfirmed": "Не удалось подтвердить вывод средств. Проверьте баланс Nado, прежде чем повторить попытку.",
    "errorWithdrawRisk": "Достигнут 24-часовой лимит вывода Nado. Попробуйте позже."
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "Карта"
  },
  "lockedTransfer": {
    "amountInfoTitle": "Сумма отправки",
    "amountInfoDescription": "Отправьте эту сумму, чтобы внести {{amount}}. Средства сверх этой суммы не будут зачислены. Для их возврата потребуется помощь службы поддержки.",
    "amountLoading": "Расчёт…",
    "amountUnavailable": "Сумма недоступна",
    "title": "Внести криптовалюту",
    "send": "Отправить",
    "amount": "Сумма",
    "address": "Одноразовый адрес пополнения",
    "copyAmount": "Скопировать сумму",
    "amountCopied": "Сумма скопирована",
    "showFullAddress": "Показать полный адрес",
    "tokenOnChain": "{{token}} в сети {{chain}}"
  },
  "selectAsset": {
    "emptyChains": "Нет доступных поддерживаемых сетей",
    "combinedTitle": "Токен и сеть отправки",
    "title": "Выберите актив",
    "empty": "Нет доступных поддерживаемых активов"
  }
}
